import { getThreadId } from '../../threads/operators/threadGetters';
const getRejectedMessagesMap = state => {
  const rejectedMessages = state.rejectedMessages;
  return rejectedMessages && typeof rejectedMessages === 'object' ? rejectedMessages : {};
};
export const getRejectedMessageForThread = (state, threadId) => {
  const rejectedMessages = getRejectedMessagesMap(state);
  const entry = Object.entries(rejectedMessages).find(([, info]) => info.threadId === threadId);
  if (!entry) {
    return null;
  }
  const [rejectedMessageId, {
    rejectionReason
  }] = entry;
  return {
    rejectedMessageId,
    rejectionReason,
    threadId
  };
};
export const getRejectedMessage = (state, thread) => {
  const threadId = thread ? getThreadId(thread) : undefined;
  if (typeof threadId === 'number') {
    return getRejectedMessageForThread(state, threadId);
  }
  const rejectedMessages = getRejectedMessagesMap(state);
  const entry = Object.entries(rejectedMessages)[0];
  if (!entry) {
    return null;
  }
  const [rejectedMessageId, {
    rejectionReason,
    threadId: tid
  }] = entry;
  return {
    rejectedMessageId,
    rejectionReason,
    threadId: tid
  };
};
export const getRejectedMessageIds = state => {
  const rejectedMessages = getRejectedMessagesMap(state);
  return new Set(Object.keys(rejectedMessages));
};
export const getRejectedMessageIdsForThread = (state, threadId) => {
  const rejectedMessages = getRejectedMessagesMap(state);
  return new Set(Object.entries(rejectedMessages).filter(([, info]) => info.threadId === threadId).map(([id]) => id));
};
export const isMessageRejected = (state, messageId) => {
  const rejectedMessages = getRejectedMessagesMap(state);
  return messageId in rejectedMessages;
};